import React, { useState } from 'react'
import Swal from 'sweetalert2'
import apiClient, { API_ENDPOINTS } from '../../config/api'

const AddWarehouse = () => {
  const [formData, setFormData] = useState({
    name: '',
    location: '',
    is_main: false
  })
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      // Prepare payload according to backend expectations
      const payload = {
        name: formData.name,
        location: formData.location || '',
        is_main: formData.is_main || false
      }

      await apiClient.post(API_ENDPOINTS.WAREHOUSES, payload)

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Created successfully!',
        confirmButtonText: 'OK'
      })

      // Reset form
      setFormData({
        name: '',
        location: '',
        is_main: false
      })
    } catch (error) {
      console.error('Error creating warehouse:', error)
      const errorMessage = error.response?.data?.name?.[0] || 
                          error.response?.data?.non_field_errors?.[0] ||
                          error.response?.data?.detail ||
                          error.response?.data?.message ||
                          'Failed to create. Please try again.'
      
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className="pagetitle">
        <h1>Add Warehouse</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item">Warehouses</li>
            <li className="breadcrumb-item active">Add Warehouse</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-building me-2"></i>
                  New Entry
                </h5>

                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <label htmlFor="name" className="col-sm-2 col-form-label">Name <span className="text-danger">*</span></label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="Enter name"
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label htmlFor="location" className="col-sm-2 col-form-label">Location</label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="location"
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                        placeholder="Enter location"
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    {/* <label htmlFor="is_main" className="col-sm-2 col-form-label">Is Main</label> */}
                    <div className="col-sm-10">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="is_main"
                          name="is_main"
                          checked={formData.is_main}
                          onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor="is_main">
                          Mark as main warehouse
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-sm-10 offset-sm-2">
                      <button 
                        type="submit" 
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Creating...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-plus-circle me-2"></i>
                            Create
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default AddWarehouse

